import Ghost from './images/MG Ghost.jpg';
export var ProductsData = [
    {
        sampler: 'Action & Adventure Manga Sampler',
        image: Ghost,
        reader: 31581
    },
    {
        sampler: 'All-Ages Manga Sampler',
        image: Ghost,
        reader: 31582
    },
    {
        sampler: 'Horror & Suspense Manga Sampler',
        image: Ghost,
        reader: 31585
    },
    {
        sampler: 'Romance Manga Sampler',
        image: Ghost,
        reader: 31586
    },
    {
        sampler: 'BL, Yuri, and LGBTQ+ Manga Sampler',
        image: Ghost,
        reader: 31583
    },
    {
        sampler: 'Essentials Manga Sampler',
        image: Ghost,
        reader: 31584
    },
];
